import GuidelineTables from "../../components/TablesAndFigures/GuidelineTables/GuidelineTables";
import GuidelineFigures from "../../components/TablesAndFigures/GuidelineFigures/GuidelineFigures";
import GuidelineOverviewRouter from "./overview/GuidelineOverviewRouter";

export const guidelinePageTabs = [
  {
    id: "overview",
    label: "Overview",
    component: GuidelineOverviewRouter,
  },
  {
    id: "tables",
    label: "Tables",
    component: GuidelineTables,
  },
  {
    id: "figures",
    label: "Figures",
    component: GuidelineFigures,
  },
];

export const pbGuidelinePageTabs = [
  {
    id: "overview",
    label: "Overview",
    component: GuidelineOverviewRouter,
  },
];

export const guidelinePageTabsSmallScreen = [
  {
    id: "topic",
    label: "Topic",
  },
  {
    id: "overview",
    label: "Overview",
    component: GuidelineOverviewRouter,
  },
  {
    id: "tables",
    label: "Tables",
    component: GuidelineTables,
  },
  {
    id: "figures",
    label: "Figures",
    component: GuidelineFigures,
  },
];

export const pbGuidelinePageTabsSmallScreen = [
  {
    id: "topic",
    label: "Topic",
  },
  {
    id: "overview",
    label: "Overview",
    component: GuidelineOverviewRouter,
  },
];